import { createStore, applyMiddleware, Action, Store } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk, { ThunkAction as RawThunkAction } from 'redux-thunk';

import rootReducer from './reducers/rootReducer';
import { FiltersState } from './reducers/filters.types';
import { ListingsSortOrderState } from './reducers/listingsSortOrder.types';
import { SearchResultsState } from './reducers/searchResults';
import { TaxonomyState } from 'reducers/taxonomy.types';
import { UserState } from 'reducers/user';

export interface RootState {
    filters: FiltersState;
    listingsSortOrder: ListingsSortOrderState;
    searchResults: SearchResultsState;
    taxonomy: TaxonomyState;
    user: UserState;
}

export type ThunkAction = RawThunkAction<
    void,
    RootState,
    unknown,
    Action<string>
>;

const middleware = [thunk];

// used in tests
export const configureStore = (initialState?: RootState) => {
    return createStore(rootReducer, initialState);
};

const makeStore = () => {
    const store = createStore(
        rootReducer,
        composeWithDevTools(applyMiddleware(...middleware))
    );

    return store;
};

export const wrapper = createWrapper<Store<RootState>>(makeStore, {
    debug: false
});
